import { EQUAL, GREATER, GREATER_OR_EQUAL, LESS, LESS_OR_EQUAL, NOT_EQUAL } from '../../../converters/crmSearch/FilterCRMSearchOperatorTypesType';
import { Equal, Greater, GreaterOrEqual, Less, LessOrEqual, NotEqual } from 'customer-data-filters-ui/filterQueryFormat/operator/Operators';
import { equalOption, greaterOption, greaterOrEqualOption, lessOption, lessOrEqualOption, notEqualOption } from './numberDurationQuickFilterUtils';
import { DATE, DATE_TIME } from 'customer-data-objects/property/PropertyTypes';
export const DEFAULT_OPERATOR = EQUAL;
export const dateDurationOperatorOptions = {
  [DATE_TIME]: [lessOption, greaterOption],
  [DATE]: [lessOption, greaterOption, lessOrEqualOption, greaterOrEqualOption, equalOption, notEqualOption]
};
const operatorTypeToOperator = {
  [EQUAL]: Equal,
  [NOT_EQUAL]: NotEqual,
  [LESS]: Less,
  [LESS_OR_EQUAL]: LessOrEqual,
  [GREATER]: Greater,
  [GREATER_OR_EQUAL]: GreaterOrEqual
};
export const mapOperatorTypeToOperator = operatorType => operatorTypeToOperator[operatorType];
export const mapOperatorNameToOperatorType = operatorName => {
  for (const key of Object.keys(operatorTypeToOperator)) {
    if (operatorTypeToOperator[key].toString() === operatorName) {
      return key;
    }
  }
  return DEFAULT_OPERATOR;
};